import { useRoute, useRouteParams } from '#imports'
import { computed } from 'vue'

import { parse } from '@backmarket/utils/query-string/parse'

export type UrlParams = Readonly<{
  productId: string
  grade?: 10 | 11 | 12
  offerType?: 7
}>

export const useUrlParams = () => {
  const { uuid: productId } = useRouteParams()
  const route = useRoute()

  const grade = computed(() => {
    const { l = null } = parse(route.hash)
    const v = Array.isArray(l) ? l[0] : l

    return v ? parseInt(v, 10) : null
  })

  const offer = computed(() => {
    const { offerType = null } = parse(route.hash)
    const v = Array.isArray(offerType) ? offerType[0] : offerType

    return v ? parseInt(v, 10) : null
  })

  return {
    productId,
    grade,
    offerType: offer,
  }
}
